export default __webpack_public_path__ + "static/media/img-0343-ukraine-full-face.75c9974d.png";